import { gql } from 'apollo-angular';

export const newsFieldsV2 = `
  edges {
    cursor
    node {
      id
      title
      text
      href
      linkText
      titleImageId
      publishedAt
      pinned
    }
  }
  pageInfo {
    hasPreviousPage
    hasNextPage
    startCursor
    endCursor
  }
`;

export const newsQueryV2 = gql`
  query publishedNewsV2($limit: Int, $offset: Int) {
    publishedNewsV2 (limit: $limit, offset: $offset) {
      ${newsFieldsV2}
    }
  }
`;

export const singleNewsFieldsV2 = `
  id
  title
  text
  publishedAt
  titleImageId
  href
  linkText
`;

export const singleNewsQueryV2 = gql`
  query getNewsV2($newsId: String!) {
    getNewsV2 (newsId: $newsId) {
      ${singleNewsFieldsV2}
    }
  }
`;

// publishedNewsPublic is not part of the content V2 migration and keeps the V1 bean, which still
// exposes the title image as a plain url.
export const publishedNewsPublicQuery = gql`
  query publishedNewsPublic($limit: Int, $offset: Int) {
    publishedNewsPublic(limit: $limit, offset: $offset) {
      edges {
        cursor
        node {
          id
          title
          text
          href
          linkText
          imageUrl
          publishedAt
          pinned
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;
